/* ===== ashi-brella: js/common.js?v=1.5 ===== */
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".mainContnts");

  // =========================
  // 共通Observer
  // =========================
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        // 共通：is-active
        el.classList.add("is-active");

        // =========================
        // タイピング
        // =========================
        if (el.classList.contains("js-typing") && !el.dataset.started) {
          el.dataset.started = "true";

          const text = el.textContent;
          el.textContent = "";

          let i = 0;
          function typing() {
            if (i < text.length) {
              el.textContent += text.charAt(i);
              i++;
              setTimeout(typing, 100);
            } else {
              el.classList.add("is-done");
            }
          }
          typing();
        }

        // =========================
        // 画像ループ
        // =========================
        if (el.classList.contains("img-loop") && !el.dataset.started) {
          el.dataset.started = "true";

          const items = el.querySelectorAll(".img");
          let current = 0;

          setInterval(() => {
            items.forEach((item) => item.classList.remove("is-show"));
            items[current].classList.add("is-show");

            current++;
            if (current >= items.length) current = 0;
          }, 1500);
        }

        observer.unobserve(el);
      });
    },
    {
      root: null,
      threshold: 0.3,
    },
  );

  // =========================
  // 監視対象まとめて登録用
  // =========================
  document
    .querySelectorAll(".js-observe, .js-typing, .img-loop, .js-fadeUp, .js-zoomOut")
    .forEach((el) => observer.observe(el));
});

// =========================
// ローディング
// =========================
const start = Date.now();

window.addEventListener("load", () => {
  const loading = document.getElementById("loading");
  const video = document.querySelector("#mv_movie video");

  const elapsed = Date.now() - start;
  const remaining = Math.max(0, 1600 - elapsed);

  setTimeout(() => {
    loading.classList.add("is-hide");

    // 動画再生
    if (video) {
      video.play().catch(() => {
        // 自動再生制限対策（念のため）
        video.muted = true;
        video.play();
      });
    }

  }, remaining);
});

/**
 * .mv-scroll の高さを hero と Window の小さい方に合わせる関数
 */
function adjustMvScrollHeight() {
  const hero = document.querySelector('.hero');
  const mvScroll = document.querySelector('.mv-scroll'); // クラス名は適宜調整してください
  
  if (hero && mvScroll) {
    const windowHeight = window.innerHeight;
    const heroHeight = hero.offsetHeight; // .hero の実際の高さを取得

    // 小さい方の値を採用して適用
    const targetHeight = Math.min(windowHeight, heroHeight);
    mvScroll.style.height = targetHeight + 'px';
  }
}

/**
 * スクロールでフェードアウトさせる処理
 */
function handleScrollFade() {
  const mvScroll = document.querySelector('.mv-scroll');
  const threshold = window.innerHeight * 0.1; // 10vh

  if (window.scrollY > threshold) {
    mvScroll.classList.add('is-hidden');
  } else {
    // mvScroll.classList.remove('is-hidden');
  }
}

// --- イベント登録 ---

// ページ読み込み時
window.addEventListener('DOMContentLoaded', () => {
  adjustMvScrollHeight();
  handleScrollFade();
});

// 画面サイズが変わった時（リサイズ対応）
window.addEventListener('resize', adjustMvScrollHeight);

// スクロールした時
window.addEventListener('scroll', handleScrollFade);

;
/* ===== ashi-brella: inline script #1 ===== */
(function (d) {
      var config = {
        kitId: "pkj8ytq",
        scriptTimeout: 3000,
        async: true,
      },
        h = d.documentElement,
        t = setTimeout(function () {
          h.className =
            h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
        }, config.scriptTimeout),
        tk = d.createElement("script"),
        f = false,
        s = d.getElementsByTagName("script")[0],
        a;
      h.className += " wf-loading";
      tk.src = "https://use.typekit.net/" + config.kitId + ".js";
      tk.async = true;
      tk.onload = tk.onreadystatechange = function () {
        a = this.readyState;
        if (f || (a && a != "complete" && a != "loaded")) return;
        f = true;
        clearTimeout(t);
        try {
          Typekit.load(config);
        } catch (e) { }
      };
      s.parentNode.insertBefore(tk, s);
    })(document);
